import React, { useRef, useEffect, useState } from "react";
import "../styles/HeroBanner.css";

const VIDEO_SRC = "/hero-video.mp4"; // your merged file in public

const HeroBanner = () => {
  const videoRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    try {
      v.load(); // makes sure it starts
      const p = v.play();
      if (p && typeof p.then === "function") {
        p.catch(() => {
          // Autoplay blocked → fallback stays
        });
      }
    } catch {
      // ignore, fallback already handles it
    }
  }, []);

  const onCanPlay = () => setIsReady(true);
  const onError = () => setFallback(true);

  return (
    <section className={`hero-banner ${fallback ? "video-fallback" : ""}`}>
      <video
        ref={videoRef}
        className={`video-bg ${isReady ? "show" : ""}`}
        src={VIDEO_SRC}
        muted
        autoPlay
        playsInline
        preload="metadata"
        onCanPlay={onCanPlay}
        onError={onError}
        disableRemotePlayback
        controls={false}
      />
      <div className="overlay" />
      <div className="hero-content">
        <h1>PMJ Logistics Solutions — Logistics, Refined</h1>
        <p>We bridge distances with precision, delivering excellence across every shipment.</p>
        <a href="#services" className="hero-btn">Explore Our Services</a>
      </div>
    </section>
  );
};

export default HeroBanner;
